import React, { useContext } from 'react';
import { Button, Stack, ThemeProvider, Typography } from '@mui/material';

import { AppDispatchContext } from 'context/app';
import { SmartHomeLightTheme } from 'global/themes';

export const NoEvents = () => {
  const dispatch = useContext(AppDispatchContext);

  return (
    <Stack
      alignItems="center"
      sx={{
        gap: '15px',
        marginTop: '30px',
      }}
    >
      <img
        src="images/no-event-recordings.png"
        alt="No event recordings"
        style={{
          maxWidth: '25vw',
        }}
      />
      <Stack spacing={2}>
        <Typography variant="h5" color="primary" fontWeight="bold">
          No event recordings
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Try adjusting your filters.
        </Typography>
      </Stack>
      <ThemeProvider theme={SmartHomeLightTheme}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => dispatch({ type: 'eventsFilterOpen', payload: true })}
        >
          Open Filters
        </Button>
      </ThemeProvider>
    </Stack>
  );
};
